import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs';
import { ToDoService } from '../to-do.service';
import { CancelRequest } from './cancel-request';

@Component({
  selector: 'cs-cancel-request',
  standalone: false,
  templateUrl: './cancel-request.component.html',
  styleUrls: ['./cancel-request.component.scss']
})
export class CancelRequestComponent implements OnInit, OnDestroy {
  public cancelRequests: Array<CancelRequest>;
  private $onDestroy = new Subject();
  public isLoading: boolean = true;

  @Output()
  public closeTodo = new EventEmitter<void>();

  constructor(private service: ToDoService, private router: Router) {}

  public ngOnDestroy(): void {
    this.$onDestroy.next(0);
    this.$onDestroy.complete();
  }

  public ngOnInit(): void {
    this.service
      .getCancelUnitRequests()
      .pipe(takeUntil(this.$onDestroy))
      .subscribe(resp => {
        this.cancelRequests = resp;
        this.isLoading = false;
      });
  }

  public requestClick(request: CancelRequest): void {
    this.router.navigate(['/crm/customers/cancel-requests/approval'], {
      queryParams: { cancelUnitId: request.cancelUnitId }
    });
    this.closeTodo.emit();
  }
}
